import { Box, List, ListItemButton, TextField, Typography } from '@mui/material'
import translate from '../../../i18n/translate'
import { useIntl } from 'react-intl'
import { organizerApi } from '../../../modules/services/organizerService'
import { useState } from 'react'
import { useDebounce } from 'react-use'

type BillAccountViewProps = {
  userId: number;
  billAccount: any
  setBillAccount: (billAccount: any) => void;
}

export const WITHDRAWAL_TYPES = {
  DEFAULT: 'default',
  DAYS: 'days'
}

export default function BillAccountView({
  userId,
  billAccount,
  setBillAccount,
}: BillAccountViewProps) {
  const intl = useIntl()
  const [, ] =  useState<any>(null)
  const [billAccountSearch, setBillAccountSearch] =  useState<string | null>(null)

  const [organizerBillAccountDataLazyFetch, { data: billAccountData, isLoading }] = organizerApi.useLazyGetOrganizerBillAccountListQuery({})

  useDebounce(
    () => {
      organizerBillAccountDataLazyFetch({ search: billAccountSearch || '', userId, take: !billAccountSearch ? 2 : 5 });
    },
    750,
    [billAccountSearch]
  );

  return (
    <Box
      my={2}
      p={2}
      display='flex'
      flexDirection='column'
      justifyContent='center'
      width={1}
      alignItems='center'
      gap={2}
    >
      <Typography>
        {intl.formatMessage({ id: 'selectOrganizerBillAccount' })}
      </Typography>
      <TextField
        key={billAccount?.id}
        value={billAccountSearch}
        onChange={(e) => setBillAccountSearch(e.target.value)}
        variant='outlined'
        color='warning'
        disabled={isLoading}
        fullWidth
        type='text'
        label={intl.formatMessage({
          id: 'billAccountNameSearchLabel'
        })}
        placeholder={intl.formatMessage({
          id: 'billAccountNameSearchLabel'
        })}
        dir='ltr'
        sx={{
          '.MuiInputBase-root.MuiInput-root:before': {
            borderBottom: '0px'
          },
          '.MuiInputBase-root.MuiInput-root:hover': {
            borderBottom: '0px'
          }
        }}
      />
      <List sx={{ width: '100%', maxHeight: '300px', overflowY: 'auto', gap: '12px' }}>
        {billAccountData?.list?.map((b: any) => (
          <ListItemButton color='warning' sx={{ border: '1px solid #e0e0e0', width: '100%', py: 1 }} key={b.id} selected={b.id === billAccount?.id} onClick={() => setBillAccount(b)} >
            <Box> 
              <Typography>
                <span>{translate('gridEventTransactionListBillAccountName')}:</span>{' '}
                {b.name}
              </Typography>
              {b.description ? (
                <Typography>
                  <span>{translate('gridEventTransactionListBillAccountDescription')}:</span>{' '}
                  {b.description}
                </Typography>
              ) : null}
              <Typography>
                <span>{translate('gridEventTransactionListBillAccountHolderName')}:</span>{' '}
                {b.holderFullName}
              </Typography>
              <Typography>
                <span>
                  {translate('gridEventTransactionListBillAccountBankName')}
                :</span>{' '}
                {b.bankName}
              </Typography>
              <Typography>
                <span>
                  {translate('gridEventTransactionListBillAccountBankNumber')}
                :</span>{' '}
                {b.bankNumber}
              </Typography>
              <Typography>
                <span>
                  {translate('gridEventTransactionListBillAccountBankAccountNumber')}
                :</span>{' '}
                {b.bankAccountNumber}
              </Typography>
              {b.idCode ? (
                <Typography>
                  <span>
                    {translate('gridEventTransactionListBillAccountIdCode')}
                  :</span>{' '}
                  {b.idCode}
                </Typography>
              ) : null}
            </Box>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
